export default "__VITE_ASSET__f1286d66__"